import { Components, Theme } from '@mui/material';

export const defaultTypography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  h1: {
    fontWeight: 700,
    letterSpacing: '0.02em',
  },
  h2: {
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  h3: {
    fontWeight: 600,
    letterSpacing: '0.01em',
  },
  h4: {
    fontWeight: 600,
    letterSpacing: '0.01em',
  },
  h5: {
    fontWeight: 500,
  },
  h6: {
    fontWeight: 500,
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.6,
  },
  body2: {
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontWeight: 400,
    lineHeight: 1.4,
  },
  button: {
    fontWeight: 600,
    letterSpacing: '0.03em',
    textTransform: 'uppercase' as const,
  },
  caption: {
    fontWeight: 400,
  },
  overline: {
    fontWeight: 500,
    letterSpacing: '0.05em',
  },
};

export const rusticCottageTypography = {
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
  h1: {
    fontWeight: 700,
    letterSpacing: '0.02em',
  },
  h2: {
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  h3: {
    fontWeight: 600,
    letterSpacing: '0.01em',
  },
  h4: {
    fontWeight: 600,
    letterSpacing: '0.01em',
  },
  h5: {
    fontWeight: 500,
  },
  h6: {
    fontWeight: 500,
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1.6,
  },
  body2: {
    fontWeight: 400,
    lineHeight: 1.5,
  },
  button: {
    fontWeight: 600,
    letterSpacing: '0.03em',
    textTransform: 'none' as const,
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontWeight: 400,
    lineHeight: 1.4,
  },
  caption: {
    fontWeight: 400,
  },
  overline: {
    fontWeight: 500,
    letterSpacing: '0.05em',
  },
};

export const createTypographyStyles = (theme: Theme): Components['MuiTypography'] => ({
  styleOverrides: {
    root: {
      // Special contexts override with higher specificity
      '.MuiAppBar-root &, .MuiToolbar-root &': {
        color: theme.palette.secondary.light, // Use theme's secondary.light instead of hard-coded color
      },
      'footer &': {
        color: '#f0e6d9', // Keep footer text light
      },
      '.MuiAppBar-root &.MuiTypography-h1, .MuiAppBar-root &.MuiTypography-h2, .MuiAppBar-root &.MuiTypography-h3, .MuiAppBar-root &.MuiTypography-h4, .MuiAppBar-root &.MuiTypography-h5, .MuiAppBar-root &.MuiTypography-h6, .MuiToolbar-root &.MuiTypography-h1, .MuiToolbar-root &.MuiTypography-h2, .MuiToolbar-root &.MuiTypography-h3, .MuiToolbar-root &.MuiTypography-h4, .MuiToolbar-root &.MuiTypography-h5, .MuiToolbar-root &.MuiTypography-h6': {
        color: theme.palette.secondary.light, // Use theme's secondary.light for navbar headers
      },
      'footer &.MuiTypography-h1, footer &.MuiTypography-h2, footer &.MuiTypography-h3, footer &.MuiTypography-h4, footer &.MuiTypography-h5, footer &.MuiTypography-h6': {
        color: '#f0e6d9', // Keep footer headers light
      },
      '.MuiAppBar-root & a, .MuiToolbar-root & a': {
        color: theme.palette.secondary.light, // Use theme's secondary.light for navbar links
      },
      'footer & a': {
        color: '#f0e6d9', // Keep footer links light
      }
    },
    // Apply rustic cottage heading colors - only used in rustic cottage theme
    h1: { color: '#3a2d21' }, // Dark wood brown for rustic cottage
    h2: { color: '#3a2d21' }, 
    h3: { color: '#3a2d21' }, 
    h4: { color: '#3a2d21' }, 
    h5: { color: '#3a2d21' }, 
    h6: { color: '#3a2d21' },
  },
}); 